import React from 'react';
import {
  ArrayHelpers,
  FormikValues,
} from 'formik';

interface IFieldArrayRefProps {
  fieldArrayHelpers: ArrayHelpers;
  // eslint-disable-next-line react/no-unused-prop-types
  values: FormikValues;
  dirty: boolean;
  children?: React.ReactNode;
}

class FieldArrayRef<T> extends React.Component<IFieldArrayRefProps> {
  addItem = (value: T): void => {
    const { fieldArrayHelpers: { push } } = this.props;

    push(value);
  };

  isDirty = (): boolean => {
    const { dirty } = this.props;
    return dirty;
  };

  getFieldArrayHelpers = (): ArrayHelpers => {
    const { fieldArrayHelpers } = this.props;
    return fieldArrayHelpers;
  };

  // eslint-disable-next-line
  render() {
    const { children } = this.props;
    return (
      <>
        {children}
      </>
    );
  }
}

export default FieldArrayRef;
